var _defs, _path, _path2, _path3, _ellipse, _circle, _circle2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServices4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.295,
    height: 54.295,
    viewBox: "0 0 54.295 54.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f78ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f067ff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M25.723,40.447A14.723,14.723,0,1,1,40.447,25.723,14.74,14.74,0,0,1,25.723,40.447Zm0-26.049A11.326,11.326,0,1,0,37.049,25.723,11.339,11.339,0,0,0,25.723,14.4Z",
    transform: "translate(13.848 13.848)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M28.157,20.148H15.7a1.7,1.7,0,0,1,0-3.4H28.157a1.7,1.7,0,0,1,0,3.4Z",
    transform: "translate(17.643 21.14)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M18.44,18.4H2.2a1.7,1.7,0,1,1,0-3.4H18.44a1.7,1.7,0,1,1,0,3.4Z",
    transform: "translate(0.633 18.931)",
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.28,
    cy: 2.333,
    rx: 2.28,
    ry: 2.333,
    transform: "translate(27.534 9.107)",
    fill: "url(#linear-gradient)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(18.32 9.107)",
    fill: "url(#linear-gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.333,
    cy: 2.333,
    r: 2.333,
    transform: "translate(9.107 9.107)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M23.2,54.295H6.219A6.225,6.225,0,0,1,0,48.074V6.221A6.225,6.225,0,0,1,6.219,0H34.485A6.225,6.225,0,0,1,40.7,6.221V18.664a1.7,1.7,0,0,1-1.7,1.7H3.392V48.074A2.831,2.831,0,0,0,6.219,50.9H23.2a1.7,1.7,0,0,1,0,3.393ZM3.392,16.967h33.92V6.221a2.831,2.831,0,0,0-2.827-2.828H6.219A2.831,2.831,0,0,0,3.392,6.221Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices4);
export default __webpack_public_path__ + "static/media/services4.13a21875c0baea3306625afb8400084a.svg";
export { ForwardRef as ReactComponent };